import React, { useState,useEffect } from 'react';
import Presenter from 'components/presenters/matching/list/JoinedMatchingRoomList';
import server from 'server/serverController2';

export default function JoinedMatchingRoomList() {
  const [roomList, setRoomList] = useState([]);
  useEffect(()=>{
    server.getRequestData('users/matching/rooms?order_by=no&order=desc',(res)=>{
      if(res.success !== 1)
      {
        return;
      }
      const jsonData = res.data;
      setRoomList(jsonData['rooms']);
    })

  },[])
  return (
    <>
      <Presenter roomList={roomList}/>
    </>
    );
}